import React from 'react'

import { sanitizeHTML } from 'utils/sanitizeHtml'

import { Text } from './HtmlFormattedText.styled'

interface HtmlFormattedTextProps {
    readonly text: string
}

function HtmlFormattedText({ text }: HtmlFormattedTextProps) {
    return (
        <Text
            dangerouslySetInnerHTML={{
                __html: sanitizeHTML(text),
            }}
        />
    )
}

export default HtmlFormattedText
